import { useMemo } from 'react'
import { getTimeZones, timeZoneLabel, timeZoneOffsetLabel } from '@/lib/timezones'
import { Combobox } from './combobox'

export function TimezoneCombobox(props: {
  value: string | null | undefined
  onChange: (value: string) => void
  id?: string
  disabled?: boolean
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}) {
  const options = useMemo(() => {
    const now = new Date()
    return getTimeZones().map((zone) => ({
      value: zone,
      label: timeZoneLabel(zone),
      hint: timeZoneOffsetLabel(zone, now),
      keywords: zone.split('/'),
    }))
  }, [])
  return (
    <Combobox
      {...props}
      onChange={(v) => v && props.onChange(v)}
      options={options}
      placeholder="Select a timezone"
      searchPlaceholder="Search timezones…"
      emptyText="No timezone found"
    />
  )
}
